// src/api/mock/navbarData.js

export const navbarMockData = [
  { name: "Home", id: "home", iconName: "Home" },
  { name: "About", id: "about", iconName: "About" },
  { name: "Scientific Program", id: "scientific-program", iconName: "ScientificProgram" },
  { name: "Speaker", id: "speaker", iconName: "Speaker" },
  { name: "Poster Guide", id: "poster-guide", iconName: "PosterGuide" },
  { name: "Our Partner", id: "partner", iconName: "partner" },
  { name: "Venue", id: "venue", iconName: "Venue" },
];